import { createPinia, setActivePinia } from 'pinia'
export { storeToRefs } from 'pinia'

import useTradeStore from './trade'
import useAccountStore from './account'
import useLeverageStore from './leverage'
import useCountryStore from './country/country'
import useUserStore from './user'
import useAuthStore from './auth'
import useSvgStore from './svg'
import useModalManagerStore from './modalManager/modalManager'
import useServerStore from './server'
import useAccountCurrencyStore from './accountCurrency'
import useExchangeStore from './exchange'
import useExternalServerStore from './externalServer'
import useExchangeRateStore from './useExchangeRateStore'
import useSocketStore from './socket'
import useAccountOptionStore, { TransactionMode } from './accountOptions'
import useMenuStore from './menu'
import useSymbolInfoStore from './symbolInfo'
import useThemeStore from './theme'
import useSecurityStore from './security'
import useMarketCalendarStore from './marketCalendar'
import useOrderStore from './order'
export {
  useAccountStore,
  useUserStore,
  useTradeStore,
  useLeverageStore,
  useAccountOptionStore,
  TransactionMode,
  useCountryStore,
  useModalManagerStore,
  useSymbolInfoStore,
  useMenuStore,
  useThemeStore,
  useServerStore,
  useAccountCurrencyStore,
  useExchangeStore,
  useExternalServerStore,
  useExchangeRateStore,
  useAuthStore,
  useSvgStore,
  useSecurityStore,
  useSocketStore,
  useMarketCalendarStore,
  useOrderStore,
}

export function resetAllStores() {
  const userStore = useUserStore()
  const accountStore = useAccountStore()
  const leverageStore = useLeverageStore()
  const accountOptionsStore = useAccountOptionStore()
  const countryStore = useCountryStore()
  const tradeStore = useTradeStore()
  const symbolInfoStore = useSymbolInfoStore()
  const menuStore = useMenuStore()
  const serverStore = useServerStore()
  const accountCurrencyStore = useAccountCurrencyStore()
  const exchangeStore = useExchangeStore()
  const externalServerStore = useExternalServerStore()
  const svgStore = useSvgStore()
  const securityStore = useSecurityStore()
  const socketStore = useSocketStore()
  const orderStore = useOrderStore()

  // 重置所有store状态（包括持久化数据）
  userStore.reset()
  accountStore.reset()
  leverageStore.reset()
  accountOptionsStore.reset()
  countryStore.reset()
  tradeStore.reset()
  menuStore.reset()
  serverStore.reset()
  accountCurrencyStore.reset()
  exchangeStore.reset()
  externalServerStore.reset()
  svgStore.reset()
  securityStore.reset()
  socketStore.reset()
  orderStore.reset()
  // 清除symbol相关缓存
  symbolInfoStore.clearAllCache()
}

const pinia = createPinia()
setActivePinia(pinia)

export default pinia
